import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    queryKeys: ["retailer_product_id", "grpid", "name", "short_description"],
    searchValue: "",
    productType: "",
  },
  sortBy: {
    sortKey: "grpid",
    reverse: true,
  },
  showResetButton: false,
  pageNumber: 1,
  prePageNumber: 1,
  tabSelected: "liveScheduled",
};

const promotionAllViewSlice = createSlice({
  name: "promotionAllView",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("SET_FILTER_DATE", (state, action) => {
        if (action.timeSelected === "start") {
          state.filter.startDateTime = action.dateTime;
        } else {
          state.filter.stopDateTime = action.dateTime;
        }
        state.pageNumber = 1;
        state.showResetButton = true;
      })
      .addCase("SEARCH_TABLE_VALUES", (state, action) => {
        state.filter.searchValue = action.searchValue;
        state.pageNumber = 1;
        state.showResetButton = action.searchValue
          ? true
          : state.showResetButton;
      })
      .addCase("SET_PROMOTION_PRODUCT_TYPE_FILTER", (state, action) => {
        state.filter.productType = action.productType || "";
        state.pageNumber = 1;
        state.showResetButton = action.productType
          ? true
          : state.showResetButton;
      })
      .addCase("SET_PAGE_NUMBER", (state, action) => {
        state.pageNumber = action.pages.page_number;
        if (action.pages.pre_page_number) {
          state.prePageNumber = action.pages.pre_page_number;
        }
      })
      .addCase("RESET_FILTER_ALL", (state) => {
        state.filter = initialState.filter;
        state.pageNumber = 1;
        state.showResetButton = false;
      })
      .addCase("CLICK_TAB", (state, action) => {
        state.tabSelected = action.status;
        state.filter = initialState.filter;
        state.showResetButton = false;
      })
      .addCase("SET_SORT_PARAM", (state, action) => {
        state.sortBy.sortKey = action.sortKey;
        state.sortBy.reverse = action.reverse;
      });
  },
});

export const selectPromotionAllView = (state) => state.promotionAllView;

export default promotionAllViewSlice.reducer;
